// Ids match M5 seed (20260729190000_firestore_migration_seeds).
export var PricePricingMode;
(function (PricePricingMode) {
    PricePricingMode[PricePricingMode["STATIC"] = 1] = "STATIC";
    PricePricingMode[PricePricingMode["VARIABLE"] = 2] = "VARIABLE";
})(PricePricingMode || (PricePricingMode = {}));
//# sourceMappingURL=price-pricing-mode.js.map